import {
  Checkbox,
  CheckboxProps,
  FormControl,
  FormControlLabel,
  FormControlLabelProps,
  FormHelperText,
} from "@mui/material";
import { FastField, FieldProps } from "formik";
import * as React from "react";

interface FormikCheckFieldProps extends Omit<FormControlLabelProps, "control"> {
  name: string;
  checkboxProps?: CheckboxProps;
}

export const FormikCheckField: React.FC<FormikCheckFieldProps> = (props) => {
  const { checkboxProps, ...rest } = props;
  return (
    <FastField name={rest.name}>
      {({ field, meta }: FieldProps<boolean>) => (
        <FormControl fullWidth>
          <FormControlLabel
            sx={{ mt: 1 }}
            {...rest}
            control={
              <Checkbox
                data-testid={rest.name}
                checked={meta.value}
                color="primary"
                {...checkboxProps}
                {...field}
              />
            }
          />
          {Boolean(meta.touched && meta.error) && (
            <FormHelperText error>{meta.error}</FormHelperText>
          )}
        </FormControl>
      )}
    </FastField>
  );
};
